import { useMemo } from "react";
import { SoftLimitContentWrapper, SoftLimitText } from "./styles";
import { AssetsService } from "app/services/AssetsService";
import { Trans } from "@similarweb/i18n-provider";
import { SOFT_LIMIT_IMG } from "./constants";

const WidgetSoftLimitPlaceholder = () => {
    const image = useMemo(() => AssetsService.assetUrl(SOFT_LIMIT_IMG), []);

    return (
        <SoftLimitContentWrapper>
            <img src={image} />
            <SoftLimitText>
                <Trans i18nKey="widget.segments.soft.limit.text" />
            </SoftLimitText>
        </SoftLimitContentWrapper>
    );
};

export default WidgetSoftLimitPlaceholder;
